import React from 'react'
import { Link } from 'react-router-dom'
import { LgySection } from 'app/components/util/lgy-section/LgySection'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'
import BasicLgyCheckbox from 'app/components/util/lgy-checkbox/BasicLgyCheckbox'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import AdminContactCards from '../components/AdminContactCards'

const DefaultToolTip = () =>
  <div>
    User must be set-up by the RLC before registration can be completed. You can
    find the Regional Loan Center (RLC) for your area at{" "}
    <a href='https://benefits.va.gov/HOMELOANS/contact_rlc_info.asp'>
      https://benefits.va.gov/HOMELOANS/contact_rlc_info.asp
    </a>
  </div>

const OtherRequestorTooltip = () =>
  <div>
    Other Requester affiliate is used to order certain liquidation appraisal
    types. User must be set-up by the RLC before registration can be completed.
    You can find the Regional Loan Center (RLC) for your area at{" "}
    <a href='https://benefits.va.gov/HOMELOANS/contact_rlc_info.asp'>
      https://benefits.va.gov/HOMELOANS/contact_rlc_info.asp
    </a>
  </div>

const LenderServicerToolTip = ({ type }) =>
  <div>
    <p>
      Adding or making changes to a {type} affiliate will result in your account
      being inactivated pending attention from your company's admin.
    </p>
    <p>
      If you are a {type} and need your {type} ID & PIN, contact your company
      administrator.
    </p>
    <p>
      If you are the active user {type} admin and need to view or reset the PIN:
    </p>
    <ol>
      <li>Open the WebLGY application</li>
      <li>
        From the top navigation bar, click Admin &gt; Reset Lender/Servicer PIN
      </li>
    </ol>
  </div>

const FfpsTooltip = () =>
  <div>
    This links user's FFPS account credentials to your LGY Hub account. To link your LGY Hub account please enter FFPS Username and Password then click submit.
  </div>

const SuccessMessage = () =>
  <div>
    Successfully updated affiliations.<br />
    <Link to='/lgyhub'>
      <button type='button'>Go to Hub Home</button>
    </Link>
  </div>

const AffiliationChangeForm = ({ affiliations, state, handleSubmit, handleChange, handleInvalid, handleReset, updateStatus, serverProperties }) => {
  const isPosting = updateStatus.posting
  const isSuccess = updateStatus.success // TODO: These were written here but there's no reducer for it, nor redux-form to handle it
  const isError = updateStatus.error
  const isInvalid = state.invalidMessage.length > 0
  const checkboxOptions = [
    { name: 'Appraiser', value: 'APPRAISER', pin: undefined, id: 'Appraiser ID', tooltip: <DefaultToolTip /> },
    { name: 'Inspector', value: 'INSPECTOR', pin: undefined, id: 'Inspector ID', tooltip: <DefaultToolTip /> },
    { name: 'Lender', value: 'LENDER', pin: 'PIN', id: 'Lender ID', tooltip: <LenderServicerToolTip type='lender' /> },
    { name: 'Servicer', value: 'SERVICER', pin: 'PIN', id: 'Servicer ID', tooltip: <LenderServicerToolTip type='servicer' /> },
    { name: 'LAPP/SAPP SAR/Underwriter', value: 'SAR', pin: undefined, id: 'SAR/Underwriter ID', tooltip: <DefaultToolTip /> },
    { name: 'Other Requester', value: 'OTHER', pin: 'PIN', id: 'Other Requester ID', tooltip: <OtherRequestorTooltip /> },
    { name: 'FFPS', value: 'FFPS', pin: 'Password', id: 'Username', tooltip: <FfpsTooltip /> }]

  return (
    <div className="lgy-affiliate">
      {affiliations && affiliations.length === 0 &&
        <LgyAlertDialog type='info' heading='Affiliate Information Required' text='Please fill out your affiliation information to complete account setup.' />}
      <LgySection id='affiliation-change-form' header='Affiliate Information' className='affiliation-change-form'>
        {isInvalid && state.invalidMessage.some(e => e === 'invalid submit') &&
          <LgyAlertDialog type='error' heading='Invalid Submission' text='You must select at least one affiliation!' />}
        {
          isError && <LgyAlertDialog
            type='error'
            heading='Update Error'
            text={updateStatus.message.includes('LGY Hub FAQs') ? <>{updateStatus.message} <a href={serverProperties?.lgyHubFAQsUrl}>https://lgy.va.gov/lgyhub/help</a></> : updateStatus.message}
          >
            {updateStatus.invalidField && affiliations.find(el => el.name === updateStatus.invalidField) && <AdminContactCards affiliate={affiliations.find(el => el.name === updateStatus.invalidField)} />}
          </LgyAlertDialog>
        }
        {isSuccess && <LgyAlertDialog type='success' heading='Update Success'><SuccessMessage /></LgyAlertDialog>}
        {!(isSuccess || isError || isInvalid) &&
          <div>You may add or remove affiliations by selecting the checkbox next to the affiliate type. If you wish
            to change your employer enter your new affiliate ID and/or PIN where indicated.</div>}
        <form autoComplete='off' className='usa-form' onSubmit={handleSubmit}>
          <fieldset>
            <legend className='usa-sr-only'>Change Affiliations Form</legend>
            <ul className='usa-unstyled-list checkbox-options'>
              {checkboxOptions.map(option =>
                <li className='checkbox-option' key={option.name}>
                  <BasicLgyCheckbox
                    id={option.name}
                    label={option.name}
                    name='affiliation-checkbox-group'
                    checked={state.affiliations.some(a => a.name === option.value && !a.deleted)}
                    autoFocus={option.name === 'Appraiser'}
                    tooltip={option.tooltip}
                    value={option.value}
                    onChange={handleChange} />
                  {state.affiliations.some(a => a.name === option.value && !a.deleted) &&
                    <div className='affiliation-change-pin-id'>
                      {option.id &&
                        <div>
                          {option.name === 'FFPS' && <div>Please enter a valid username and password to affiliate your FFPS Account</div>}
                          <BasicLgyInputField
                            id={option.id}
                            label={option.id}
                            type='text'
                            name={`ID${option.value}`}
                            maxLength='10'
                            minLength={option.value === 'LENDER' || option.value === 'SERVICER' ? '10' : undefined}
                            required={option.value === 'FFPS'}
                            tooltip={(option.value === 'SAR' ? `Please add leading zeros if your ${option.id} is less than 6 digits.` :
                              (option.value === 'LENDER' || option.value === 'SERVICER') ? `Please enter the full 10-digit ${option.id}.` : (option.value === 'FFPS' ? 'Please enter FFPS Username' : undefined))}
                            dirty={affiliations.some(a => a.name === option.value) ?
                              state.affiliations.find(a => a.name === option.value).id !== affiliations.find(a => a.name === option.value).id ? 1 : 0 : undefined}
                            error={state.invalidMessage[option.id] ? state.invalidMessage[option.id] : undefined}
                            onChange={handleChange}
                            onInvalid={handleInvalid}
                            value={state.affiliations.find(a => a.name === option.value).id} />
                          {(option.value === 'LENDER' || option.value === 'SERVICER') && state.affiliations.find(a => a.name === option.value).institutionName}
                          {(option.value === 'SAR' && state.affiliations.some(a => a.name === 'SAR' && (a.lappSar || a.underwriter))) &&
                            <span>{`Lender: ${state.affiliations.find(a => a.name === option.value).lenderName}`}<br /></span>}
                          {(option.value === 'SAR' && state.affiliations.some(a => a.name === 'SAR' && a.sappSar)) &&
                            <span>{`Servicer: ${state.affiliations.find(a => a.name === option.value).servicerName}`}</span>}
                        </div>}
                      {option.pin &&
                        <div>
                          <BasicLgyInputField
                            id={`${option.name} ${option.pin}`}
                            label={option.pin}
                            type='text'
                            name={`PIN${option.value}`}
                            maxLength={option.name === 'FFPS' ? 80 : 8}
                            required={!!!state.affiliations.find(a => a.name === option.value).institutionName}
                            tooltip={option.value === 'FFPS' ? 'Please enter FFPS Password' : undefined}
                            error={state.invalidMessage[`${option.name} ${option.pin}`] ? state.invalidMessage[`${option.name} ${option.pin}`] : undefined}
                            onChange={handleChange}
                            onInvalid={handleInvalid}
                            value={state.affiliations.find(a => a.name === option.value).pin} />
                          {(option.value === 'SAR') && state.affiliations.find(a => a.name === option.value).institutionName}
                        </div>}
                    </div>}
                </li>)}
            </ul>
            <div className='affiliation-change-buttons'>
              <LgyFormSubmit submitting={isPosting} submitFailed={isError} submitSucceeded={isSuccess} invalid={isInvalid} reset={handleReset} />
            </div>
          </fieldset>
        </form>
      </LgySection>
    </div>
  )
}

export default AffiliationChangeForm
